import React from 'react'
import { isPerfX, WHITE_LOGO_CDN_URL } from '../constants/constants'

const AuthLayout: React.FC<{ children: React.ReactNode[] | React.ReactNode, action?: React.ReactNode, leftAction?: React.ReactNode, contentMinHeight?: string }> = ({ children, action, leftAction, contentMinHeight }) => {
    return (
        <div className='full-screen auth-bg'>
            {
                (action || leftAction) ? (
                    <div className="auth-layout-actions">
                        <div>{leftAction}</div>
                        <div>{action}</div>
                    </div>
                ) : null
            }
            <div className='auth-brand d-flex align-items-center justify-content-center flex-column'>
                <img src={WHITE_LOGO_CDN_URL} className='auth-brand-logo' style={{ height: isPerfX ? '4.75rem' : '2.75rem' }} />
                <span className='auth-brand-tagline'>Where your influence matters</span>
                <span className="auth-bg-grid">
                <svg xmlns="http://www.w3.org/2000/svg" width="360" height="311" viewBox="0 0 360 311" fill="none">
                    <path d="M-94.9802 -50L-94.9802 311M-66.8672 -50L-66.8672 311M-38.7542 -50L-38.7542 311M-10.6412 -50L-10.6412 311M17.4718 -50L17.4718 311M45.5848 -50L45.5848 311M73.6978 -50L73.6979 311M101.811 -50L101.811 311M129.924 -50L129.924 311M158.037 -50L158.037 311M186.15 -50L186.15 311M214.263 -50L214.263 311M242.376 -50L242.376 311M270.489 -50L270.489 311M298.602 -50L298.602 311M326.715 -50V311M354.828 -50V311M382.941 -50V311M411.054 -50V311M439.167 -50V311M-131 -18.4125H491M-131 10.4675H491M-131 39.3475H491M-131 68.2275H491M-131 97.1075H491M-131 125.987H491M-131 154.867H491M-131 183.747H491M-131 212.627H491M-131 241.507H491" stroke="url(#paint0_radial_1738_10772)" stroke-opacity="0.3" stroke-width="0.42" />
                    <defs>
                        <radialGradient id="paint0_radial_1738_10772" cx="0" cy="0" r="1" gradientTransform="matrix(1.75708 180.5 -262.705 2.69875 180 130.5)" gradientUnits="userSpaceOnUse">
                            <stop stopColor="white" />
                            <stop offset="0.95951" stopColor="white" stopOpacity="0" />
                        </radialGradient>
                    </defs>
                </svg>
                </span>
            </div>
            <div className="auth-content" style={{ ...(contentMinHeight ? { minHeight: contentMinHeight } : {}) }}>
                {children}
            </div>
            <div className="auth-circles"></div>
        </div>
    )
}

export default AuthLayout